const Marquee = ({ items }) => {
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-b border-[#E7E2DA] bg-[#F4EFEA] py-4 select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-editorial-marquee whitespace-nowrap">
        {doubled.map((name, i) => (
          <span key={`${name}-${i}`} className="flex items-center">
            <span className="font-serif italic text-lg text-[#44403C] px-6">
              {name}
            </span>
            <span className="text-[#C2410C] text-xs">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
